module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/1b8e87bc9f65b5e61bbaa4b7b5fa9916.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Gold/Gold5.svg
// module id = LMoJ
// module chunks = 1